<template>
  <el-row :gutter="10">
  <el-col :span="4">
    <el-select v-model="fromData.wuJianId" @change="selectAllEcharts" clearable placeholder="物件名称">
      <el-option
          v-for="item in wuJianNames"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </el-col>
  <el-col :span="4">
    <el-date-picker v-model="fromData.day" @change="selectAllEcharts" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month" placeholder="选择月份" :clearable="false" />
  </el-col>
  </el-row>

<!-- 生产性-->
  <div style="margin-top: 30px">
  <div v-loading="zuliProductiveOutputLoading" element-loading-text="数据加载中" style="width: 100%;height: 350px" id="zuliProductiveOutput"/>
  </div>

</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgZuLiProductive",
  data() {
    return {
      wuJianNames: [],
      fromData: {
        day: this.getDateFormat(),
        wuJianId:''
      },
      //物件日生产性
      zuliProductiveOutput: {
        title: [
          {
            text: '组立生产性',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '0' ,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min:0,
            max:100,
            interval:20,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(0)
              }
            }
          },
          {
            type: 'value',
            name: '',
            min:0,
            max:10,
            interval:0.5,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1)
              }
            }
          }
        ],
        series: [
          {
            name: '产量套数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '工数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '面积',
            type: 'line',
            color:'#A67D3D',
            areaStyle: {
              opacity : 0.4
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '目标生产性',
            type: 'line',
            color:'#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '実績生産性',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '累计生産性',
            color:'#9932CD',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliProductiveOutputLoading: false,

    }
  },
  methods:{
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)}
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/wujianPlan/getWujianName');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    //物件生产性
    async getDayProductiveOutput() {
      if (!this.fromData.day){
        return this.$message.error('请先选择物件月份!')
      }
      this.zuliProductiveOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliProductive/getzuliProductive',this.fromData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.zuliProductiveOutput.xAxis[0].data = res.data.xAxis
        this.zuliProductiveOutput.series[0].data = res.data.produceNum
        this.zuliProductiveOutput.series[1].data = res.data.produceArtificial
        this.zuliProductiveOutput.series[2].data = res.data.produceArea
        this.zuliProductiveOutput.series[3].data = res.data.expectedProductivity
        this.zuliProductiveOutput.series[4].data = res.data.actualProductivity
        this.zuliProductiveOutput.series[5].data = res.data.accumulateProductivity

        let a = this.$common.getDivisor(Math.max(...res.data.produceArea))
        let b = this.$common.getDivisor(Math.max(...res.data.accumulateProductivity))
        this.zuliProductiveOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.produceArea)/a)*a
        this.zuliProductiveOutput.yAxis[0].interval = Math.round(this.zuliProductiveOutput.yAxis[0].max/5*100)/100
        this.zuliProductiveOutput.yAxis[1].max = Math.ceil(Math.max(...res.data.accumulateProductivity)/b)*b
        this.zuliProductiveOutput.yAxis[1].interval = Math.round(this.zuliProductiveOutput.yAxis[1].max/5*0.5)/0.5
      }
      this.renderEcharts('zuliProductiveOutput',this.zuliProductiveOutput)

      this.zuliProductiveOutputLoading = false
    },
    selectAllEcharts(){
      this.getDayProductiveOutput()
    },
  },
  mounted() {
    this.selectAllEcharts()
  },
  created() {
    this.getWuJianInFo()

  }
}
</script>

<style scoped>

</style>